<div class="flex max-w-screen-xl w-full mx-auto flex-col lg:flex-row gap-5 bg-white rounded-3xl shadow-tertiary">
  <div class="flex flex-col gap-20 w-full p-8 about-us-section">

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.introduction" | translate }}</h2>
      <p class="subtitle" [innerHTML]="'about_us.introduction_sentence' | translate"></p>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.our_mission" | translate }}</h2>
      <p class="subtitle" [innerHTML]="'about_us.our_mission_sentence' | translate"></p>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.what_we_do" | translate }}</h2>

      <ul class="flex flex-col gap-2 !list-disc !list-inside">
        @for (message of ('about_us.what_we_do_sentence' | translate); track message) {
          <li class="subtitle" [innerHTML]="message"></li>
        } 
      </ul>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.why_us" | translate }}</h2>

      <ul class="flex flex-col gap-2 !list-disc !list-inside">
        @for (message of ('about_us.why_us_sentence' | translate); track message) {
          <li class="subtitle" [innerHTML]="message"></li>
        } 
      </ul>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.our_location" | translate }}</h2>
      <p class="subtitle" [innerHTML]="'about_us.our_location_sentence' | translate"></p>
    </div>


    <div class="flex flex-col gap-4">
      <h1 class="bigTitle">{{ "about_us.gender_equality" | translate }}</h1>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.gender_equality_mission" | translate }}</h2>
      <p class="subtitle" [innerHTML]="'about_us.gender_equality_mission_sentence' | translate"></p>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.gender_equality_vision" | translate }}</h2>
      <p class="subtitle" [innerHTML]="'about_us.gender_equality_vision_sentence' | translate"></p>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.gender_equality_values" | translate }}</h2>

      <ul class="flex flex-col gap-2 !list-disc !list-inside">
        @for (message of ('about_us.gender_equality_values_sentence' | translate); track message) {
          <li class="subtitle" [innerHTML]="message"></li>
        } 
      </ul>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.gender_equality_objectives" | translate }}</h2>

      <ul class="flex flex-col gap-2 !list-disc !list-inside">
        @for (message of ('about_us.gender_equality_objectives_sentence' | translate); track message) {
          <li class="subtitle" [innerHTML]="message"></li>
        } 
      </ul>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "about_us.gender_equality_law_referred" | translate }}</h2>
      <p class="subtitle" [innerHTML]="'about_us.gender_equality_law_referred_sentence' | translate"></p>
    </div>
  </div>
</div>